import { INSERT_UNORDERED_LIST_COMMAND, REMOVE_LIST_COMMAND } from "@lexical/list";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import FormatListBulleted from "@mui/icons-material/FormatListBulleted";
import { IconButton, type IconButtonProps, Tooltip } from "@mui/material";
import { type FC, type MouseEventHandler, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ToolbarIconButton } from "./toolbar-icon-button";

interface BulletedListButtonProps extends IconButtonProps {
  label?: string;
  activeBlockType: boolean;
}

export const BulletedListButton: FC<BulletedListButtonProps> = ({
  disabled,
  label,
  onClick,
  activeBlockType,
  ...props
}) => {
  const { t } = useTranslation();
  const [editor] = useLexicalComposerContext();

  const handleClick: MouseEventHandler<HTMLButtonElement> = useCallback(
    (e) => {
      editor.dispatchCommand(
        activeBlockType ? REMOVE_LIST_COMMAND : INSERT_UNORDERED_LIST_COMMAND,
        undefined,
      );
      onClick?.(e);
    },
    [editor, onClick, activeBlockType],
  );

  return (
    <>
      {label ? (
        <ToolbarIconButton
          data-analytics-id="lexical-toolbar-bulleted-list"
          disabled={disabled}
          data-testid="toolbar-button-bulleted-list"
          aria-label={t("Bulleted list")}
          onClick={handleClick}
          label={label}
          icon={<FormatListBulleted />}
          {...props}
        />
      ) : (
        <Tooltip title={t("Bulleted list")}>
          <span>
            <IconButton
              data-analytics-id="lexical-toolbar-bulleted-list"
              disabled={disabled}
              data-testid="toolbar-button-bulleted-list"
              aria-label="Bulleted list"
              tabIndex={-1}
              onClick={handleClick}
              {...props}
            >
              <FormatListBulleted />
            </IconButton>
          </span>
        </Tooltip>
      )}
    </>
  );
};
